"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useNotificationData = exports.NotificationProvider = exports.NotificationContext = void 0;
var _mui = require("@ori-ui/mui");
var _react = _interopRequireWildcard(require("react"));
var _useTranslations = require("../hooks/useTranslations");
var _TranslationKey = require("../models/TranslationKey");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var MessageType = /*#__PURE__*/function (MessageType) {
  MessageType["error"] = "error";
  MessageType["info"] = "info";
  MessageType["success"] = "success";
  MessageType["warning"] = "warning";
  return MessageType;
}(MessageType || {});
const StyledAlert = (0, _mui.styled)(_mui.Alert)(() => ({
  width: '100%'
}));
const NotificationContext = exports.NotificationContext = /*#__PURE__*/(0, _react.createContext)({
  notificationData: {
    setNotificationData: () => {}
  }
});
const NotificationProvider = ({
  children
}) => {
  const [notificationData, setNotificationData] = (0, _react.useState)({});
  const {
    formatMessage
  } = (0, _useTranslations.useTranslations)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(NotificationContext.Provider, {
    value: {
      notificationData: {
        notificationData,
        setNotificationData
      }
    },
    children: [children, notificationData.isOpen ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Box, {
      display: "flex",
      justifyContent: "center",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Snackbar, {
        open: true,
        autoHideDuration: 4000,
        onClose: () => setNotificationData({
          isOpen: false
        }),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledAlert, {
          onClose: () => setNotificationData({
            isOpen: false
          }),
          severity: notificationData.type,
          variant: "filled",
          children: notificationData.message ?? formatMessage(_TranslationKey.TranslationKey.errorOccured)
        })
      })
    }) : null]
  });
};
exports.NotificationProvider = NotificationProvider;
const useNotificationData = () => {
  const ctx = (0, _react.useContext)(NotificationContext);
  return {
    context: ctx
  };
};
exports.useNotificationData = useNotificationData;
